export default {
  profile: {
    person_research_interview: "v1/person/{0}/research_interview",
    research_interview: "v1/research_interview",
    personSkills: "v1/person/{0}/skill",
    profileSkills: "v1/profile/{0}/skill",
    personSkill: "v1/person/{0}/skill/{1}",
    profileSkill: "v1/profile/{0}/skill/{1}",
    userIdChangeInfo: "v1/user/{0}/change_info",
    skill: "v1/skill",
    hozehGHazayiForTerm: "v1/hozeh-ghazayi-term",
    hozehTerms: "v1/hozeh-ghazayi-term/{0}/hozeh",
    hozehTermsProvince: "v1/hozeh-ghazayi-province/{0}",
    hozehGhazayiTermDetail: "v1/hozeh-ghazayi-term/{0}/details",
    hozehGhazayiConfigId: "v1/hozeh-ghazayi-term/{0}/config",
    person_cooperation: "v1/person/{0}/person_cooperation",
    personAzmoon: "v1/person/{0}/azmoon",
    profileAzmoon: "v1/profile/{0}/azmoon",
    person_job_experience: "v1/person/{0}/job",
    personRelations: "v2/person/{0}/person_relation",
    profileRelations: "v2/profile/{0}/person_relation",
    personRelation: "v2/person/{0}/person_relation/{1}",
    profileRelation: "v2/profile/{0}/person_relation/{1}",
    person_license_create: "v1/person/{0}/license",
    userChangeInfo: "v1/user-change-info",
    person_license: "v1/person/{0}/license/{1}",
    person_wife_relation: "v1/person/{0}/wife_relation/{1}",
    person_years_of_service: "v1/person/{0}/person_years_of_service/{1}",
    person_years_of_service_create: "v1/person/{0}/person_years_of_service",
    person_wife_relation_create: "v1/person/{0}/wife_relation",
    person_family_relation: "v1/person/{0}/family_relation/{1}",
    person_family_relation_create: "v1/person/{0}/family_relation",
    peron_free_course: "v1/person/{0}/free_course/{1}",
    peron_free_course_create: "v1/person/{0}/free_course",
    person_contact: "v1/person/{0}/contact/{1}",
    person_contact_create: "v1/person/{0}/contact",
    person_address: "v1/person/{0}/address/{1}",
    person_address_create: "v1/person/{0}/address",
    person_work_experience_create: "v1/person/{0}/job",
    person_education: "v1/person/{0}/education/{1}",
    userChangeMobile: "v1/user-change-mobile",
    userChangePass: "v1/user-change-pass",
    personIndependentRelation: "v1/fa/person/{0}/introducer/{1}",
    profileIndependentRelation: "v1/fa/profile/{0}/introducer/{1}",
    personIndependentRelations: "v1/fa/person/{0}/introducer",
    profileIndependentRelations: "v1/fa/profile/{0}/introducer",
    azmoon_execute:
      "v1/azmoon-execute/{0}/person/{1}/operator/{2}/reference/{3}",
    person_education_create: "v1/person/{0}/education",
    person_social: "v1/person/{0}/social/{1}",
    person_social_create: "v1/person/{0}/social",
    person_information_create: "v1/person/{0}/text",
    person_work_experience: "v1/person/{0}/job/{1}",
    person_article: "v1/person/{0}/article/{1}",
    person_article_create: "v1/person/{0}/article",
    person_allotment: "v1/person/{0}/allotment",
    user_code_generate_temp_password: "v1/user/{0}/generate_temp_password",
    parvandeh: "v1/parvandeh",
    person_financial: "v1/person_financial/{0}",
    generate_otp_code: "v1/generate_otp_code",
    parvandeh_status_count_incomplete: "v1/parvandeh/{0}/status",
    person_has_data: "v1/person/{0}/person_has_data",
    refresh_parvandeh_status: "v1/parvandeh_status/calculate",
    term_state: "v1/term/{0}/term_state",
    term_state_id: "v1/term/{0}/term_state/{1}",
    edit_term_state: "v1/term/{0}/term_state/{1}",
    term_order: "v1/term/order",
    term_state_order: "v1/term_state/order",
    change_mobile: "v1/user/change_mobile",
    person_tags: "v1/person/{0}/tag",
    parvandeh_hozeh_ghazayi_delete: "v1/parvandeh/{0}/hozeh_ghazayi",
    hozeh_ghazayi_reset: "v1/hozeh_ghazayi_reset/{0}",
    enum: "v1/enum",
    enum_id: "v1/enum/{0}",
    enum_detail: "v1/enum/{0}/detail",
    enum_type: "v1/enum/{type}",
    enum_order: "v1/enumeration/order",
    enum_grouped: "v1/enum/grouped",
    import_inquiry: "v1/import_inquiry",
    person_identity_change: "v1/person_identity_change",
    person_identity_change_id: "v1/person_identity_change/{0}",
    form_manual_register: "v1/form_manual_register",
    excel_manual_register: "v1/excel_manual_register",
    parvandeh_report: "v1/parvandeh/{0}/parvandeh_report",
    term_extra_profile: "v1/term_extra_profile/{0}",
    term_extra_attachment: "v1/term_extra_attachment/{0}",
    report_access: "v1/report_access",
    report_access_id: "v1/report_access/{0}",
    report_settings: "v1/report_settings",
    enum_editable: "v1/enum_category",
    enum_gender_category: "v1/enum_category/{0}/enums",
    province: "v1/filter/province",
    parvandeh_archive: "v1/parvandeh_archive",
    user_id: "v1/user/{0}",
    whats_new: "v1/whats_new",
    whats_new_id: "v1/whats_new/{0}",
    user_change_pass: "v1/user/change_pass",
    user_change_mobile: "v1/user/change_mobile",
    term: "v1/term",
    term_id: "v1/term/{0}",
    term_register_code: "v1/term/{0}/term_register_code",
    term_register_code_id: "v1/term/{0}/term_register_code/{1}",
    import_term_register_code: "v1/term/{0}/import_term_register_code",
    change_user_pass: "v1/user/{0}/change_pass",
    person_teaching_experience_create: "v1/fa/person/{0}/teaching-experience",
    person_teaching_experience: "v1/fa/person/{0}/teaching-experience/{1}",
    companies: "v1/company",
    company: "v1/company/{0}",
    companyContacts: "v1/company/{0}/contact",
    companyContact: "v1/company/{0}/contact/{1}",
    companyAddresses: "v1/company/{0}/address",
    companyAddress: "v1/company/{0}/address/{1}",
    companyAttachments: "v1/fa/attachment-company/{0}",
    companyAttachment: "v1/fa/attachment-company/{0}/attachment/{1}",
    profileAttachments: "v1/attachment-profile/{0}",
    profileAttachment: "v1/attachment-profile/{0}/attachment/{1}",
    personAttachments: "v1/attachment-person/{0}",
    personAttachment: "v1/attachment-person/{0}/attachment/{1}",
    personSpecials: "v1/person/{0}/attachment-special",
    personSpecial: "v1/person/{0}/attachment-special/{1}",
    profileTabs: "v1/profile/{0}/tabs",
    personTabs: "v1/person/{0}/tabs",
    person: "v1/person/{0}",
    profile: "v1/profile/{0}",
    profileIdentityChangeCode: "v1/profile/{0}/identity_change",
    personIdentityChangeCode: "v1/person/{0}/identity_change",
    personAdminIdentityChangeCode: "v1/person/{0}/admin_identity_change",
    personInfo: "v1/person-info/{0}",
    profileInfo: "v1/profile-info/{0}",
    personInformation: "v1/person/{0}/information",
    profileInformation: "v1/profile/{0}/information",
    profileContacts: "v1/profile/{0}/contact",
    personContacts: "v1/person/{0}/contact",
    profileContact: "v1/profile/{0}/contact/{1}",
    personContact: "v1/person/{0}/contact/{1}",
    profileAddresses: "v1/profile/{0}/address",
    personAddresses: "v1/person/{0}/address",
    profileAddress: "v1/profile/{0}/address/{1}",
    personAddress: "v1/person/{0}/address/{1}",
    profileJobs: "v1/profile/{0}/job",
    personJobs: "v1/person/{0}/job",
    profileJob: "v1/profile/{0}/job/{1}",
    personJob: "v1/person/{0}/job/{1}",
    profileEducations: "v1/profile/{0}/education",
    personEducations: "v1/person/{0}/education",
    profileEducation: "v1/profile/{0}/education/{1}",
    personEducation: "v1/person/{0}/education/{1}",
    profileSocials: "v1/profile/{0}/social",
    personSocials: "v1/person/{0}/social",
    profileSocial: "v1/profile/{0}/social/{1}",
    personSocial: "v1/person/{0}/social/{1}",
    profileAllotments: "v1/profile/{0}/allotment",
    personAllotments: "v1/person/{0}/allotment",
    profileAllotment: "v1/profile/{0}/allotment/{1}",
    personAllotment: "v1/person/{0}/allotment/{1}",
    profileLicenses: "v1/profile/{0}/license",
    personLicenses: "v1/person/{0}/license",
    profileLicense: "v1/profile/{0}/license/{1}",
    personLicense: "v1/person/{0}/license/{1}",
    profileFreeCourses: "v1/profile/{0}/free_course",
    personFreeCourses: "v1/person/{0}/free_course",
    profileFreeCourse: "v1/profile/{0}/free_course/{1}",
    personFreeCourse: "v1/person/{0}/free_course/{1}",
    profileArticles: "v1/profile/{0}/article",
    personArticles: "v1/person/{0}/article",
    profileArticle: "v1/profile/{0}/article/{1}",
    personArticle: "v1/person/{0}/article/{1}",
    profileWifeRelations: "v1/profile/{0}/wife_relation",
    personWifeRelations: "v1/person/{0}/wife_relation",
    profileWifeRelation: "v1/profile/{0}/wife_relation/{1}",
    personWifeRelation: "v1/person/{0}/wife_relation/{1}",
    profileFamilyRelations: "v1/profile/{0}/family_relation",
    personFamilyRelations: "v1/person/{0}/family_relation",
    profileFamilyRelation: "v1/profile/{0}/family_relation/{1}",
    personFamilyRelation: "v1/person/{0}/family_relation/{1}",
    profileFinancials: "v1/profile/{0}/financial",
    personFinancials: "v1/person/{0}/financial",
    profileYearsOfServices: "v1/profile/{0}/years_of_service",
    personYearsOfServices: "v1/person/{0}/years_of_service",
    profileYearsOfService: "v1/profile/{0}/years_of_service/{1}",
    personYearsOfService: "v1/person/{0}/years_of_service/{1}",
    profileTeachingExperiences: "v1/fa/profile/{0}/teaching-experience",
    personTeachingExperiences: "v1/fa/person/{0}/teaching-experience",
    profileTeachingExperience: "v1/fa/profile/{0}/teaching-experience/{1}",
    personTeachingExperience: "v1/fa/person/{0}/teaching-experience/{1}",
    profileHasData: "v1/profile/{0}/has_data",
    personHasData: "v1/person/{0}/has_data",
    parvandehStatus: "v1/parvandeh/{0}/status",
    folders: "v1/folder",
    folder: "v1/folder/{0}",
    folderAccessRole: "v1/folder_access/{0}/role",
    folderAccessParvandeh: "v1/folder_access/{0}/parvandeh",
    foldersParvandeh: "v1/folder/{0}/parvandeh",
    folderParvandeh: "v1/folder/{0}/parvandeh/{1}",
    folderParvandehRelation: "v1/folder-parvandeh-relation",
    folderFullAccess: "v1/folder-full-access",
    parvandehId: "v1/parvandeh/{0}",
    parvandehCancel: "v1/parvandeh_cancel",
    personIdentityChanges: "v1/person_identity_change",
    personIdentityChange: "v1/person_identity_change/{0}",
    parvandehRole: "v1/parvandeh/{0}/role",
    parvandehRoleLog: "v1/parvandeh/{0}/role_log",
    roles: "v1/role",
    role: "v1/role/{0}",
    rolePermissionCopy: "v1/role/{0}/permission_copy",
    rolePermissionGroup: "v1/role/{0}/permission-group/{1}",
    rolePermissions: "v1/role/{0}/permissions",
    termExtraTab: "v1/term_extra_tab/{0}",
    userBlockList: "v1/user-block-list",
    userUnblock: "v1/user/{0}/unblock",
    adminLoginHistory: "v1/admin-session-history",
    adminLoginHistoryDelete: "v1/admin-login-history/{0}/delete",
    adminLoginHistoryUserParvandeh:
      "v1/admin-session-history/user/{0}/parvandeh",
    userLastLoginHistory: "v1/last-login-history/user/{0}",
    myLastLoginHistory: "v1/my-last-login-history",
    userStatus: "v1/user/{0}/status",
    userChangeUsername: "v1/user-change-username",
    userChangeEmail: "v1/user-change-email",
    profileParvandehTabs: "v1/my-parvandeh-tabs",
    personParvandehTabs: "v1/other-parvandeh-tabs/{0}",
    profileParvandehGrade: "v1/my-parvandeh/grade",
    personParvandehGrade: "v1/parvandeh/{0}/grade",
    personParvandehInterview: "v1/parvandeh/{0}/interview",
    personParvandehAzmoon: "v1/parvandeh/{0}/azmoon",
    personParvandehResearch: "v1/parvandeh/{0}/research",
    roleFolderLimit: "v1/role/{0}/folder-limit",
    profileParvandehPayments: "v1/my-parvandeh/payments",
    personParvandehPayments: "v1/parvandeh/{0}/payments",
    profileParvandehPaymentNoNeed: "v1/my-parvandeh/payment_no_need",
    personParvandehPaymentNoNeed: "v1/parvandeh/{0}/payment_no_need",
    profileParvandehRegistrationInformation:
      "v1/my-parvandeh/registration-information",
    personParvandehRegistrationInformation:
      "v1/parvandeh/{0}/registration-information",
    personParvandehProfileInquiries: "v1/parvandeh/{0}/profile-inquiries",
    personParvandehHozehGhazayi: "v1/parvandeh/{0}/hozeh-ghazayi",
    personParvandehCommitment: "v1/parvandeh/{0}/commitment",
    personParvandehQualification: "v1/parvandeh/{0}/qualification",
    allHozehGhazayi: "v1/all_hozeh_ghazayi",
    readyHozehGhazayi: "v1/ready-hozeh-ghazayi",
    readyHozehGhazayiId: "v1/ready-hozeh-ghazayi/{0}",
    resetHozehGhazayi: "v1/reset-hozeh-ghazayi",
    hozehGhazayi: "v1/hozeh_ghazayi",
    hozehGhazayiId: "v1/hozeh_ghazayi/{0}",
    hozehGhazayiTermConfig: "v1/hozeh-ghazayi-term/{0}/config",
    hozehGhazayiTermId: "v1/hozeh-ghazayi-term/{0}/hozeh/{1}",
    importHozehGhazayi: "v1/hozeh-ghazayi-term/{0}/excel-all-hozeh",
    termRole: "v1/term/{0}/role",
    importHozehGhazayiTermProvince:
      "v1/hozeh-ghazayi-term/{0}/excel-province-hozeh",
    hozehGhazayiTermImport: "v1/hozeh-ghazayi-term/import",
    folderImportExcel: "v1/folder-import-excel",
    whatsNewVersionList: "v1/whats-new-version-list",
    whatsNewVersionDetail: "v1/whats-new-detail/{0}",
    whatsNewImportExcel: "v1/whats-new-import-excel",
    licenseField: "v1/fa/markazjazb/license-field",
    licenseFieldId: "v1/fa/markazjazb/license-field/{0}",
    termLicenseField: "v1/fa/markazjazb/term-license-field",
    termLicenseFieldCode: "v1/fa/markazjazb/term-license-field/{0}",
    termLicenseFieldId: "v1/fa/markazjazb/term/{0}/license-field",
    termLicenseFieldClone: "v1/fa/markazjazb/term/{0}/license-field-clone",
    parvandehTermLicenseField:
      "v1/fa/markazjazb/term/{0}/parvandeh-term-license-field",
    parvandehTermLicenseFieldId:
      "v1/fa/markazjazb/parvandeh-term-license-field/{0}",
    parvandehTermLicenseFieldImportExcel:
      "v1/fa/markazjazb/term/{0}/parvandeh-term-license-field-import-excel",
    v2: {
      parvandeh: "v2/parvandeh",
      parvandeh_archive: "v2/parvandeh_archive",
      term: "v2/term/{0}",
      term_id_register: "v2/term/{0}/register",
      user_id: "v2/user/{0}",
      importManualRegister: "v2/fa/import-manual-register",
      termImportRegisterCode: "v2/fa/term/{0}/import-term-register-code",
      roles: "v2/role_tree",
    },
  },
};
